import { render } from "./TurnoForm.vue?vue&type=template&id=58ca990c&scoped=true"
import script from "./TurnoForm.vue?vue&type=script&lang=js"
export * from "./TurnoForm.vue?vue&type=script&lang=js"

import "./TurnoForm.vue?vue&type=style&index=0&id=58ca990c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ca990c"]])

export default __exports__